import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements OnInit {
  @Input() pdfSrc: any;
  page: number = 1;
  constructor() {}

  ngOnInit(): void {}
  pageChanging(e: any) {
    this.page = e.pageNumber;
  }
  downloadPdf() {
    window.open(this.pdfSrc);
  }
  nextPage() {
    this.page++;
  }
  prevPage() {
    this.page--;
  }
  updatePageNumber(e: any) {
    console.log(e);
  }
}
